import React from 'react';
import BonificationReports from './BonificationReports';

interface BonificationStatsProps {
  color: string;
}

const BonificationStats: React.FC<BonificationStatsProps> = ({ color }) => {

  // Since we're only showing logs now, we don't need to wait for the summary data
  return (
    <div className="bonification-logs">
      <BonificationReports color={color} />
    </div>
  );
};

export default BonificationStats;